import Typography from '@mui/material/Typography'
import {Box, IconButton} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {classes, StyledDivider} from './SummaryComponentStyles'
import CustomBox from '../../common/CustomBox'
import PropTypes from 'prop-types'

const SummaryHeader = ({setSidebarOpen, sidebarOpen, handlePersonaCustomLabel}) => {
  return (
    <CustomBox className={classes.summaryCustomBox}>
      <div className={classes.mainSummaryContainer}>
        <CustomBox className={classes.summaryHeaderCustomBox}>
          <Typography className={classes.summaryTitle} tabIndex={0}>
            {handlePersonaCustomLabel(null, 'Drivers of Health Personas')}
          </Typography>
          <Box>
            <IconButton
              data-testid="close-testSidebar"
              id="close-test-sidebar"
              aria-label="close-testSidebar"
              className={classes.closeButton}
              onClick={() => {
                setSidebarOpen({...sidebarOpen, open: !sidebarOpen.open})
                document.getElementById('persona-list-panel')?.focus({preventScroll: true})
              }}
              size="large"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </CustomBox>
        <Typography className={classes.summaryParagraph} tabIndex={0}>
          These Personas help to tailor your outreach and target interventions by better understanding social,
          environmental, economic, and behavioral influences on health and health access across different populations.
        </Typography>
      </div>

      <StyledDivider />
    </CustomBox>
  )
}

SummaryHeader.propTypes = {
  sidebarOpen: PropTypes.object.isRequired,
  setSidebarOpen: PropTypes.func,
  handlePersonaCustomLabel: PropTypes.func.isRequired
}

export default SummaryHeader
